define("shared/utils/search/sort-search-results-by-match-ratio", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class sortSearchResultsByMatchRatio
   * @extends Utils
   */

  /**
   *
   * @method sortSearchResultsByMatchRatio
   * @param {Array} query
   *
   * @return {Array} Array of search results ordered by value of match ratio
   */

  const sortSearchResultsByMatchRatio = rawSearchResults => rawSearchResults.sort((resultPrev, resultCurr) => resultPrev.matchRatio < resultCurr.matchRatio ? 1 : -1);
  var _default = _exports.default = sortSearchResultsByMatchRatio;
});